import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../components/Admin/GreetingsTop/GreetingsTop';
import PurchaseOrderTable from '../../../components/Logistic/PurchaseOrderTable/PurchaseOrderTable';
import BackButton from '../../../components/General/BackButton/BackButton';

export default function Administration() {
  return (
    <Layout>
      <GreetingsTop />
      <HeaderTop />
      <div className="catalog__container">
        <PurchaseOrderTable />
      </div>
    </Layout>
  );
}

function HeaderTop({ type }) {
  const { Title } = Typography;

  return (
    <div className="catalog__container">
      <Row className="header-top">
        <Col md={20} xs={20} className="header-top__left">
          <Title
            level={3}
            style={{
              // position: 'absolute',
              top: 0,
              bottom: 0,
              height: '78%',
              margin: 'auto',
            }}
          >
            Ordenes de compra
          </Title>
        </Col>
        <Col xs={4}>
          <Row
            style={{
              marginBottom: 30,
              justifyContent: 'right',
            }}
          >
            <BackButton routeName={'/cxp/proveedor'}></BackButton>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
